import React, { Component } from 'react';

import { Pagination, Checkbox, Modal, message, Spin } from 'antd';

import utils from './../../utils/index';

import fetch from './../../services/fetch';
import file from './../../services/dossier/document/file';

class DataGrid extends Component {
    constructor(props) {
        super(props);

        this.state = {
            grid: {
                columns: [],
                result: [],
                selects: [],
                size: 0,
                pageSize: 0,
                total: 0,
                checked: false,
                notify: "",
                left: 0,
                right: 120
            },
            scale: 0,

            offset: {
                left: 0,
                top: 0
            },

            pagination: {
                pageNum: 1,
                pageSize: 100
            },

            view: {
                left: 50,
                right: 120
            },

            colresize: {
                left: 0,
                width: 50
            },

            keywords: {

            },
            loading: true,
            visible: false,
        }

        this.dragData = {};
    }

    componentDidMount() {
        this.winhash = window.location.hash;

        //QuerySearch Grid Data
        this.querySearch(Object.assign({}, this.state.pagination, this.props.keywords || {}));
        const grid = {
            columns: [],
            size: 0
        };

        this.props.service.headers.columns.forEach( column => {
            if(column.hasOwnProperty('type') === false) {
                grid.columns.push(column);
            }

            if(column.type === 'selection') {
                grid.left = 40;
            }
            
            if(column.type === 'action') {
                grid.right = column.width || 100;
            }
        });

        this.viewport = this.refs.viewport;

        let size = 0;

        this.props.service.headers.columns.forEach(column => {
            size += column.width || 0;
        });

        grid.size = size;

        var columnFilter = this.props.service.headers.columns.filter(column => {
            return !column.type;
        })

        const scale = Math.max((this.viewport.offsetWidth - size) / (columnFilter.length), 0);

        this.setState({
            scale
        })

        grid.columns = grid.columns.map((column, index) => {
            return Object.assign({}, column, {
                width: column.width + scale,
                x: column.x + scale * (index + 1)
            });
        });

        grid.size += Math.max((this.viewport.offsetWidth - size), 0);

        this.setState({
            grid: Object.assign({}, this.state.grid, grid)
        });

        this.props.service.setRefresh(() => {
            this.refresh();
        });

        this.bindDocumentMouseMove();
        this.bindDocumentMouseUp();
    }

    refresh() {
        this.querySearch(Object.assign({}, this.state.pagination, this.state.keywords));
    }

    querySearch(params = {}) {
        this.setState({
            loading: true
        });

        return this.props.service.querySearch(params)
        .then(data => {
            const grid = this.updateGrid(this.header || this.props.service.headers);
            
            this.setState({
                index: -1,
                grid: Object.assign({}, this.state.grid, data, grid),
                loading: false
            });

            if(this.props.setMetaData) {
                this.props.setMetaData(data.meta);
            }

            if(this.props.service.onSelect) {
                this.props.service.onSelect([]);
            }

            if(this.props.service.onSelectData) {
                this.props.service.onSelectData([]);
            }

            // setTimeout(() => {
            //     this.setState({
            //         loading: false
            //     });
            // }, 1000);
            
        }).catch(error => {
            this.setState({
                loading: false
            });
        });
    }

    updateDataRowById(id) {
        this.props.service.redirect('/update/'+ id);
    }

    removeDataRowById(ids) {
        this.props.service.remove(ids)
        .then(response => {
            if(response.code === 200) {
                message.success(response.message);
                this.refresh();
            }
        }); 
    }

    updateGrid(header) {
        const grid = {
            columns: [],
            size: 0
        };

        header.columns.forEach( column => {
            if(column.hasOwnProperty('type') === false) {
                grid.columns.push(column);
            }

            if(column.type === 'selection') {
                grid.left = 40;
            }
            
            if(column.type === 'action') {
                grid.right = column.width || 120;
            }
        });

        let size = 0;

        header.columns.forEach(column => {
            size += column.width || 0;
        });

        grid.size = size;

        var columnFilter = header.columns.filter(column => {
            return !column.type;
        })

        const scale = Math.max((this.viewport.offsetWidth - size - 10) / (columnFilter.length), 0);

        grid.columns = grid.columns.map((column, index) => {
            return Object.assign({}, column, {
                width: column.width + scale,
                x: column.x + scale * (index + 1)
            });
        });

        grid.size += Math.max((this.viewport.offsetWidth - size), 0);

        return grid;
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.header) {
            this.header = nextProps.header;
        } else {
            this.header = this.props.service.headers;
        }

        // if(nextProps.hasOwnProperty('keywords')) {
        //     this.setState({
        //         keywords: nextProps.keywords
        //     });

        //     if(nextProps.keywords.hasOwnProperty('loading')) {
        //         this.setState({
        //             loading: nextProps.keywords.loading
        //         })
        //     }
            
        //     if(this.watchPropsChange(nextProps.keywords)) {
        //         //update header;
        //         this.querySearch(Object.assign({}, this.state.pagination, nextProps.keywords));
        //     }
        // }

        if(nextProps.hasOwnProperty('keywords')) {
            if(nextProps.keywords.loading === true) {
                this.setState({
                    loading: nextProps.keywords.loading
                });
            } else {
                // this.setState({
                //     loading: false
                // });
                if(nextProps.keywords.v && nextProps.keywords.v !== this.v) {
                    const keywords = Object.assign({}, this.state.keywords, this.state.pagination, nextProps.keywords);

                    if(!this.props.ismodal) {
                        const defaultKeywords = utils.getKeywords(this.winhash);
                    
                        utils.setKeywords(Object.assign({}, defaultKeywords, keywords), this.winhash);
                    }
                    

                    this.v = nextProps.keywords.v;
                    this.setState({
                        keywords
                    });
                    this.querySearch(keywords);
                }  else if(nextProps.keywords.loading === false) {
                    this.setState({
                        loading: false
                    });
                }
            }   
        }
    }

    watchPropsChange(keywords) {
        var isChanged = false;
        for(let key in keywords) {
            if(key === 'loading' && (keywords.loading === true || keywords.loading === undefined)) {
                isChanged = false;
                break;
            } else if(keywords[key] !== this.state.keywords[key]) {  
                isChanged = true;
                break;
            } 
        }
        
        return isChanged;
    }

    onScroll(event) {
        const viewport = event.target;
        const left = -viewport.scrollLeft;
        const top = -viewport.scrollTop;

        this.refs.colresize.style.top = Math.abs(top) + 'px';

        this.setState(function (prevState, props) {
            return {
                offset: {
                    left, top
                }
            }
        })
    }

    onChange(pageNum) {

        

        if(!this.props.ismodal) {
            const defaultKeywords = utils.getKeywords();

            utils.setKeywords(Object.assign({}, defaultKeywords, {
                pageNum
            })); 
        }

        const pagination = Object.assign({}, this.state.pagination, {pageNum});
        this.setState({
            pagination
        });
        this.querySearch(Object.assign({}, this.state.keywords, pagination, this.props.keywords, {pageNum}));
    }

    onShowSizeChange(current, pageSize) {
        if(!this.props.ismodal) {
            const defaultKeywords = utils.getKeywords();

            utils.setKeywords(Object.assign({}, defaultKeywords, {
                pageSize
            })); 
        }

        const pagination = Object.assign({}, this.state.pagination,  this.props.keywords, {pageSize});

        this.setState({
            pagination
        });
        
        this.querySearch(pagination);
    }

    showTotal(total) {
        return `总记录数： ${total} 条`;
    }

    onSelectAll(checked) {
        const selects = this.state.grid.selects
        .map(d => Object.assign({}, d, {checked: checked}));

        this.setState({
            grid: Object.assign({}, this.state.grid, {selects, checked})
        });

        this.props.service.onSelect(checked ? selects.map(select => select.value) : []);
    }

    onSelect(checked, value) {
        const selects = this.state.grid.selects
        .map(select => {
            if(select.value === value) {
                return {
                    value: select.value,
                    fileStatus: select.fileStatus,
                    templateId: select.templateId,
                    checked: !select.checked,
                    height: select.height || 30
                }
            }
            return select;
        });

        const checkeds = selects.filter(d => {
            return d.checked;
        });

        const ischeck = (checkeds.length === selects.length) ? true : false;

        this.setState({
            grid: Object.assign({}, this.state.grid, {selects, checked: ischeck})
        });

        this.props.service.onSelect(checkeds.map(select => select.value));

        if(this.props.service.onResultStateSelect) {
            var ids = checkeds.map(select => select.value);
            var resultState = this.state.grid.result.filter(item => {
                return item.id ===ids[0];
            }).map(item => {
                return {
                    value: item.id,
                    state: item.resultState
                }
            });

            this.props.service.onResultStateSelect(resultState);
        }
        
    }

    onGridHeaderMouseDown(target, pageX, index) {
        this.isSetGridHeaderSize = true;
        this.dragStartOffsetLeft = pageX;

        const headers = this.refs.headers;
        
        const columns = headers.querySelectorAll('li');
        const handlers = headers.querySelectorAll('span.data-grid-inline');

        this.dragData = {
            width: this.state.grid.columns[index].width,
            x: this.state.grid.columns[index].x - this.state.grid.columns[index].width,
            index: index,
            column: columns[index],
            handlers: handlers
        };

        this.refs.colresize.style.width = (this.dragData.width + 1) + 'px';
        this.refs.colresize.style.left = this.dragData.x + 'px';
    }

    onDraggable(offsetMoveX) {
        const offsetX = offsetMoveX - this.dragStartOffsetLeft;
        const offsetWidth = this.minColumnWidth(this.dragData.width + offsetX);
        const column = this.dragData.column;
        const handlers = this.dragData.handlers;
        const index = this.dragData.index;
        const x = this.dragData.x;

        column.style.width = offsetWidth + 'px';

        this.state.grid.columns.slice(index).forEach((data, i) => {
            handlers[index + i].style.left = (data.x + (offsetWidth - this.dragData.width) + 40 + this.state.offset.left) + 'px';
        });

        this.dragData.offsetLeft = offsetWidth - this.dragData.width;
        this.dragData.offsetWidth = offsetWidth;

        this.refs.colresize.style.width = (offsetWidth + 1) + 'px';
        this.refs.colresize.style.left = x + 'px';
    }

    bindDocumentMouseMove() {
        window.document.addEventListener('mousemove', (event) => {
            if(this.isSetGridHeaderSize) {
                this.onDraggable(event.pageX);
            }
        })
    }

    bindDocumentMouseUp() {
        window.document.addEventListener('mouseup', () => {
            if(this.isSetGridHeaderSize && this.dragData.offsetLeft) {
                const columns = this.state.grid.columns.map((column, i) => {
                    if(i === this.dragData.index) {
                        return Object.assign(column, {
                            width: this.dragData.offsetWidth,
                            x: column.x + this.dragData.offsetLeft
                        });
                    } else if(i > this.dragData.index) {
                        return Object.assign(column, {
                            x: column.x + this.dragData.offsetLeft
                        });
                    }
    
                    return column;
                });
    
                let size = 0;
    
                columns.forEach(column => {
                    size += column.width;
                });
    
                this.setState({
                    grid: Object.assign(this.state.grid, {size, columns})
                });
            }

            if(this.refs.colresize) {
                this.refs.colresize.style.left = '-9999px';
            }
            this.isSetGridHeaderSize = false;
        });
    }

    minColumnWidth(width) {
        return Math.max(50, width);
    }

    setSelection(grid, offset) {
        const types = this.props.service.headers.columns.filter(column => column.type === 'selection');
        const { evalClassName } = this.props;
        if(types.length) {
            return (
                <div className="data-grid-selects-wrapper">
                    <div className="data-grid-selects">
                        <ul className="data-grid-header-checkeds">
                            <li className="first-child">
                                <Checkbox checked={grid.checked} onChange={(event) => {
                                    this.onSelectAll(event.target.checked);
                                }}></Checkbox>
                            </li>
                        </ul>
                        <ul className={evalClassName ? "data-grid-body-checkeds data-grid-evals" : "data-grid-body-checkeds"} style={{top: offset.top}}>
                            {
                                grid.selects.map(row => (
                                    <li style={{height: row.height || 30 }}>
                                        <Checkbox value={row.value} checked={row.checked} onChange={(event) => {
                                            this.onSelect(event.target.checked, row.value);
                                        }}></Checkbox>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </div>
            );
        }
        return '';
    }

    update(row) {
        return (
            <a href="javascript:;" onClick={() => {
                this.updateDataRowById(row.value);
            }}>修改</a> 
        )
    }

    remove(row) {
        return (
            <a href="javascript:;" onClick={() => {
                Modal.confirm({
                    title: '确定删除该记录？',
                    content: '删除后将无法恢复！',
                    onOk() {
                        this.removeDataRowById([row.value]);
                    },
                    onCancel() {},
                    okText:"确认",
                    cancelText:"取消"
                });
                
            }}>删除</a>
        )
    }

    read(row) {
        return row.fileList[0] && row.fileList[0].viewLook == 1 ? <a href='javascript:;' title="查看" onClick={() => {
            this.isFileExist(row.fileList[0].id, `${fetch.base}dossier/file/view/${row.fileList[0].id}`);
            return false;
        }} ><i className="fa fa-eye-slash" aria-hidden="true"></i></a> : '';
    }

    video(row) {
        return row.fileList[0] && row.fileList[0].viewLook == 2 ? <a href='javascript:;' title="浏览视频" onClick={() => {
            this.isFileVideoExist(row.fileList[0].id);
            return false;
        }} ><i className="fa fa-video-camera" aria-hidden="true"></i></a> : '';
    }

    image(row) {
        return row.fileList[0] && row.fileList[0].viewLook == 3 ? <a href='javascript:;' title="预览图片" onClick={() => {
            this.isFileExist(row.fileList[0].id, `${fetch.base}dossier/file/view/${row.fileList[0].id}`);
            return false;
        }} ><i className="fa fa-file-image-o" aria-hidden="true"></i></a> : '';
    }

    down(row) {
        return row.isDownload && row.fileList[0] ? <a href='javascript:;' title="下载" onClick={() => {
            this.isFileExist(row.fileList[0].id, `${fetch.base}dossier/file/download/${row.fileList[0].id}`);
        }}><i className="fa fa-download" aria-hidden="true"></i></a> : '';
    }

    file(row) {
        return row.attachment ? <a href="javascript:;" title="文件" onClick={() => {
            if(typeof this.props.attachmentHandle === 'function') {
                this.props.attachmentHandle(row);
            }
        }}><i className="fa fa-file-pdf-o" aria-hidden="true"></i></a> : '';
    }

    isFileVideoExist(id){
        file.exist(id).then((response) => {
            if(response.code === 404) {
                Modal.error({
                    title: '文件不存在',
                    content: (
                        <div>
                        <p>请确认文件是否存在！</p>
                        </div>
                    ),
                    okText:"确认",
                    onOk() {},
                });
            } else {
                this.props.viewVideo(id);
            }
        })
    }

    isFileExist(id, url) {
        file.exist(id).then((response) => {
            if(response.code === 404) {
                Modal.error({
                    title: '文件不存在',
                    content: (
                        <div>
                        <p>请确认文件是否存在！</p>
                        </div>
                    ),
                    okText:"确认",
                    onOk() {},
                });
            } else {
                const anchor = this.refs.anchor;
                anchor.setAttribute('href', url);
                anchor.setAttribute('target', '_blank');
                anchor.click();
            }
        })
    }

    setActions(grid, offset) {
        const types = this.props.service.headers.columns.filter(column => column.type === 'action');
        if(types.length) {
            return (
                <div className="data-grid-actions-wrapper data-grid-action-file-wrapper" style={{width: grid.right}}>
                    <div className="data-grid-actions">
                        <ul className="data-grid-header-actions">
                            <li className="first-child">操作</li>
                        </ul>
                        <ul className={"data-grid-body-actions"} style={{top: offset.top}}>
                            {
                                grid.result.map(row => (
                                    <li style={{height: row.height || 30}}>
                                        {
                                            types[0].values.map(type => (
                                                typeof this[type] === 'function' ? this[type](row) : ''
                                            ))
                                        }
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </div>
            );
        }
        return '';
    }

    handleCancel() {
        this.setState({
            visible: false
        });
    }

    setSortColumn(sort, order) {
        var keywords = Object.assign({}, this.state.keywords, this.props.keywords,  this.state.pagination, {sort, order});
        this.setState({
            keywords
        });
        this.querySearch(keywords);
    }

    onRowClick(index){
        const selects = this.state.grid.selects.map((select, i) => {
            if(index === i) {
                return {
                    value: select.value,
                    fileStatus: select.fileStatus,
                    templateId: select.templateId,
                    checked: true,
                    name: select.name,
                    height: select.height || 30
                }
            }
            return {
                value: select.value,
                fileStatus: select.fileStatus,
                templateId: select.templateId,
                checked: false,
                name: select.name,
                height: select.height || 30
            };
        });

        const checkeds = selects.filter(d => {
            return d.checked;
        });

        const ischeck = (checkeds.length === selects.length) ? true : false;

        this.setState({
            index: index,
            grid: Object.assign({}, this.state.grid, {selects, ischeck})
        });

        this.props.service.onSelect(checkeds.map(select => select.value));


        if(this.props.service.onSelectData) {
            this.props.service.onSelectData(selects);
        }

        if(this.props.onSelect) {
            this.props.onSelect(ischeck);
        }
    }

    render () {
        const { evalClassName, classNames } = this.props;
        const { grid, offset } = this.state;
        return (
            <div className={classNames ? "root-main root-domain5" : 'root-main'}>
                <a id="window-data-grid-blank" ref="anchor"></a>
                <div className="data-grid">
                    <div className="data-grid-container">
                        <div className="data-grid-header" ref="headers" >
                            <ul className="data-grid-columns" style={{marginLeft:offset.left, paddingLeft: grid.left, paddingRight: grid.right}}>
                                {/* <li style={{width: 50}}>序号</li> */}
                                {
                                    grid.columns.map(column => (
                                        <li style={{width: column.width}} >
                                            <span className="data-grid-columns-label">{column.label}</span>
                                            <span className="grid-sort-up" onClick={() => {
                                                this.setSortColumn(column.key, 'asc');
                                            }}><i className="fa fa-sort-up" /></span>
                                            <span className="grid-sort-down"
                                            onClick={() => {
                                                this.setSortColumn(column.key, 'desc');
                                            }}><i className="fa fa-sort-down" /></span>
                                        </li>
                                    ))
                                }
                            </ul>
                            {
                                grid.columns.map((column, index) => (
                                    <span className="data-grid-inline" 
                                    style={{left: (column.x + 40 + offset.left)}} 
                                    onMouseDown={(event) =>{
                                        this.onGridHeaderMouseDown(event.target, event.pageX, index);
                                    }}>
                                    </span>
                                ))
                            }
                        </div>
                        <Spin  tip="数据加载中..." spinning={this.state.loading}>
                        <div className="data-grid-body" style={{paddingLeft: grid.left, paddingRight: grid.right}}>
                            <div className="data-grid-viewport" ref="viewport" onScroll={this.onScroll.bind(this)}>
                                <div className="data-grid-content" >
                                    <div className={evalClassName ? "data-grid-main data-grid-evals" :"data-grid-main"}>
                                    {
                                        grid.result.map((row, index) => (
                                            <ul className={index === this.state.index ? "data-grid-row data-grid-selected" : "data-grid-row" }
                                            style={{height: row.height || 30}}
                                             onClick={() => {
                                                this.onRowClick(index);
                                             }}
                                             >
                                                {/* <li style={{width: 50}}>{index + 1}</li> */}
                                                {
                                                    grid.columns.map((column, $index) => (
                                                        <li style={{width: column.width, height: row.height || 30}}>
                                                            {
                                                                $index === 0 ? (index + 1) : (
                                                                    column.render ? column.render(row[column.key], row, () => {
                                                                        this.querySearch(Object.assign({}, this.state.pagination, this.props.keywords || {}));
                                                                    }) : row[column.key]
                                                                )
                                                            }
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        ))
                                    }
                                    {
                                        grid.notify ? <div className="data-notify">{grid.notify}...</div> : ''
                                    }
                                    </div>
                                    <div className="data-grid-column-resize" ref="colresize"></div>
                                </div>                              
                            </div>
                        </div>
                        </Spin>

                        {
                            this.setSelection(grid, offset)
                        }

                        {
                            this.setActions(grid, offset)
                        }

                        <div className="data-grid-footer">
                            <Pagination size="small" current={grid.pageIndex}  total={grid.total} showTotal={this.showTotal.bind(this)} onChange={this.onChange.bind(this)} onShowSizeChange={this.onShowSizeChange.bind(this)} showSizeChanger showQuickJumper pageSizeOptions={[50, 100, 200, 500, 1000]} defaultPageSize={100} pageSize={+grid.pageSize} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DataGrid;